import { TableHead, TableRow, TableCell, Typography } from '@mui/material'
import type { FC } from 'react'

const TableHeader: FC = () => (
  <TableHead>
    <TableRow>
      <TableCell width={250}>
        <Typography variant="subtitle2">Name</Typography>
      </TableCell>
      <TableCell width={100}>
        <Typography variant="subtitle2">Skill level</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="subtitle2"></Typography>
      </TableCell>
      <TableCell width={110}>
        <Typography variant="subtitle2"></Typography>
      </TableCell>
    </TableRow>
  </TableHead>
)

export default TableHeader
